export function ArrayUtil() {}

ArrayUtil.getLength = function (array: any[]) {
  if (array.length > 0) return array.length;
  else {
    let length = 0;
    for (const key in array) {
      if (array.hasOwnProperty(key)) length++;
    }
    return length;
  }
};

ArrayUtil.valueAt = function (array, index, def) {
  if (array.hasOwnProperty(index)) return array[index];
  else return def;
};
ArrayUtil.contains = function (array, element) {
  let i = array.length;
  while (i--) {
    if (array[i] == element) {
      return true;
    }
  }
  return false;
};
ArrayUtil.insert = function (array, index, item) {
  array.splice(index, 0, item);
  return array;
};
ArrayUtil.remove = function (array, item) {
  array.splice(array.indexOf(item), 1);
  return item;
};
ArrayUtil.removeAll = function (array, toRemove) {
  for (let i = array.length - 1; i >= 0; i--) {
    const item = array[i];
    if (ArrayUtil.contains(toRemove, item)) {
      ArrayUtil.remove(array, item);
    }
  }
};

////JASON: we changed the signature to make it compile, but i think this is just unused. can we remove?
//ArrayUtil.replace = function (array, item, replacement){
//	return array.splice(array.indexOf(item), 1, replacement);
//}

////JASON: we changed the signature to make it compile, but i think this is just unused. can we remove?
//ArrayUtil.replaceAll = function (array, item, replacement)
//{
//	while(array.indexOf(item)>=0){
//		array.splice(array.indexOf(item), 1, replacement);
//	}
//	return array;
//}

ArrayUtil.concat = function (array, array2) {
  return array.concat(array2);
};
ArrayUtil.fill = function (array, value, count) {
  array = array || [];
  //value = value || 0;
  count = count || 0;

  if (count == 0) count = array.length;
  for (let i = 0; i < count; i++) {
    array[i] = value;
  }
  return array;
};
ArrayUtil.sortOn = function (array, props) {
  return array.sort(function (a, b) {
    let p;
    if (props instanceof Array) p = props.slice();
    else p = [props];
    let prop = p.shift();
    while (a[prop] == b[prop] && props.length) prop = p.shift();
    return a[prop] == b[prop] ? 0 : a[prop] > b[prop] ? 1 : -1;
  });
};
ArrayUtil.split = function (string, delimiter) {
  return string.split(delimiter);
};
ArrayUtil.join = function (array, delimiter) {
  if (array.join) return array.join(delimiter);
  else {
    let str = '';
    let first = true;
    for (const i in array) {
      if (first) first = false;
      else str += delimiter;
      str += array[i];
    }
    return str;
  }
};
ArrayUtil.copy = function <T>(array: readonly T[] | null): T[] | null {
  if (array != null) {
    return array.slice(0);
  } else {
    return null;
  }
};
ArrayUtil.clone = function (array) {
  if (array && array.length && typeof array != 'string' && array.length > 0) {
    const newArr = [];
    for (const i in array) {
      newArr[i] = ArrayUtil.clone(array[i]);
    }
    return newArr;
  } else return array;
};

ArrayUtil.find = function (array, prop, value, findAll) {
  const found = findAll ? ([] as any[]) : null;
  for (const i in array) {
    const o = array[i];
    if (o[prop] == value) {
      if (findAll) found!.push(o);
      else return o;
    }
  }
  return found;
};

ArrayUtil.sameContents = function (array1, array2) {
  if (array1.length != array2.length) return false;
  const array1Copy = ArrayUtil.copy(array1);
  for (const i in array2) {
    if (ArrayUtil.contains(array1Copy, array2[i])) {
      ArrayUtil.remove(array1Copy, array2[i]);
    } else {
      return false;
    }
  }
  return true;
};

ArrayUtil.getProperty = function (
  obj: object | null | undefined,
  prop: string | readonly (string | number)[],
) {
  //console.log( prop, prop.length, prop instanceof Array );
  if (!obj) return null;
  if (Array.isArray(prop)) {
    const propArr = ArrayUtil.copy(prop)!;
    while (propArr.length) {
      const o = obj;
      if (!o) return null;
      const p = propArr.shift()!;
      obj = o[p];
      //console.log( obj, p );
    }
    //console.log( ">>>", obj );
    return obj;
  } else return obj[prop as string];
};

/* Analytics */

ArrayUtil.sum = function (array, prop?) {
  let sum = 0;
  for (const i in array) {
    if (prop == null) sum += array[i];
    else sum += array[i][prop];
  }
  return sum;
};
ArrayUtil.max = function (array, prop?) {
  if (prop == null) {
    return Math.max.apply(null, array);
  } else {
    let currentMax = array[0][prop];
    for (const i in array) {
      currentMax = Math.max(currentMax, array[i][prop]);
    }
    return currentMax;
  }
};
ArrayUtil.min = function (array, prop?) {
  if (prop == null) {
    return Math.min.apply(null, array);
  } else {
    let currentMin = array[0][prop];
    for (const i in array) {
      currentMin = Math.min(currentMin, array[i][prop]);
    }
    return currentMin;
  }
};
ArrayUtil.ratios = function (array) {
  const ratioArr = [] as number[];
  const sum = ArrayUtil.sum(array);
  for (const i in array) {
    ratioArr[i] = array[i] / sum;
  }
  return ratioArr;
};
ArrayUtil.tally = function (array, ratios?) {
  let tally = {};
  for (const i in array) {
    tally['' + array[i]] = ArrayUtil.valueAt(tally, array[i], 0) + 1;
  }
  if (ratios) tally = ArrayUtil.ratios(tally);
  return tally;
};
ArrayUtil.forEach = function (array, func, passIndex?, args?) {
  if (args == null) args = [];
  if (passIndex) args.unshift(null);
  args.unshift(null);
  for (let i = 0; i < array.length; i++) {
    args[0] = array[i];
    if (passIndex) args[1] = i;
    func.apply(null, args);
  }
  return array;
};
ArrayUtil.generateWithFunction = function (
  length,
  func,
  thisArg?,
  argArray?,
  unique?: boolean,
) {
  thisArg = thisArg || null;
  argArray = argArray || null;
  unique = unique || false;

  const array = [] as any[];
  while (array.length < length) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const val = func.apply(thisArg, argArray);
    if (!unique || array.indexOf(val) < 0) {
      array.push(val);
    }
  }
  return array;
};
